import React from "react";
import { motion } from "framer-motion";

export function ArchetypeCard({ archetype }) {
    return (
        <div
            className="relative overflow-hidden rounded-3xl border border-klareet-bor bg-klareet-card p-8 md:p-10 animate-fade-up"
            data-testid="archetype-card"
        >
            <div
                className="absolute inset-x-0 top-0 h-1"
                style={{ background: archetype.color }}
                aria-hidden
            />
            <div
                className="absolute -top-16 -right-16 w-52 h-52 rounded-full blur-3xl opacity-20 pointer-events-none"
                style={{ background: archetype.color }}
                aria-hidden
            />
            <div className="flex items-start gap-6">
                <motion.div
                    className="text-6xl leading-none shrink-0"
                    animate={{ y: [-4, 4, -4] }}
                    transition={{
                        duration: 3,
                        repeat: Infinity,
                        ease: "easeInOut",
                    }}
                    aria-hidden
                >
                    {archetype.emoji}
                </motion.div>
                <div className="min-w-0">
                    <div className="text-[11px] uppercase tracking-[0.2em] text-klareet-MUT font-mono">
                        You are a
                    </div>
                    <h1
                        className="mt-2 text-4xl md:text-5xl font-semibold tracking-tight"
                        style={{ color: archetype.color }}
                    >
                        {archetype.name}
                    </h1>
                    <p className="mt-5 text-lg md:text-xl text-klareet-TEXT/90 italic leading-relaxed max-w-prose">
                        “{archetype.line}”
                    </p>
                </div>
            </div>
        </div>
    );
}
